
<h3>Open Source Software (OSS) Copyright </h3>

<p>
</p>
<p>
    This application uses various open source software.
</p>
<p>
    Angular (https://github.com/angular/angular)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Angular-auth-oidc-client
    (https://github.com/damienbod/angular-auth-oidc-client)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    ASPNet SignalR (https://github.com/SignalR/SignalR/)
</p>
<p>
    Licensed under the Apache 2.0 license.
</p>
<p>
    AutoMapper (https://www.nuget.org/packages/AutoMapper/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    AutoMapper.Extensions.Microsoft.DependencyInjection
    (https://www.nuget.org/packages/AutoMapper.Extensions.Microsoft.DependencyInjection/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Azure.Identity (https://www.nuget.org/packages/Azure.Identity/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Azure.Messaging.EventHubs
    (https://www.nuget.org/packages/Azure.Messaging.EventHubs/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Azure.Messaging.EventHubs.Processor
    (https://www.nuget.org/packages/Azure.Messaging.EventHubs.Processor/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Azure.Security.KeyVault.Certificates
    (https://www.nuget.org/packages/Azure.Security.KeyVault.Certificates/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Azure.Security.KeyVault.Secrets
    (https://www.nuget.org/packages/Dapr.Client/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Azure.Storage.Blobs (https://www.nuget.org/packages/Azure.Storage.Blobs/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    bootstrap (https://github.com/twbs/bootstrap)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Dapper (https://www.nuget.org/packages/Dapper/)
</p>
<p>
    Licensed under the Apache 2.0 license.
</p>
<p>
    Dapr.AspNetCore (https://www.nuget.org/packages/Dapr.AspNetCore/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Dapr.Client (https://www.nuget.org/packages?q=Dapr.Client)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    FluentValidation (https://www.nuget.org/packages/FluentValidation/)
</p>
<p>
    Licensed under the Apache 2.0 license.
</p>
<p>
    IdentityModel (https://www.nuget.org/packages/IdentityModel/)
</p>
<p>
    Licensed under the Apache 2.0 license.
</p>
<p>
    IdentityServer4 (https://www.nuget.org/packages/IdentityServer4/)
</p>
<p>
    Licensed under the Apache 2.0 license.
</p>
<p>
    IdentityServer4.AccessTokenValidation
    (https://www.nuget.org/packages/IdentityServer4.AccessTokenValidation/)
</p>
<p>
    Licensed under the Apache 2.0 license.
</p>
<p>
    IdentityServer4.AspNetIdentity
    (https://www.nuget.org/packages/IdentityServer4.AspNetIdentity/)
</p>
<p>
    Licensed under the Apache 2.0 license.
</p>
<p>
    IdentityServer4.EntityFramework
    (https://www.nuget.org/packages/IdentityServer4.EntityFramework/)
</p>
<p>
    Licensed under the Apache 2.0 license.
</p>
<p>
    JsonFlatten (https://www.nuget.org/packages/JsonFlatten/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Kendo Angular UI (https://github.com/telerik/kendo-angular)
</p>
<p>
    Licensed under the Apache 2.0 license.
</p>
<p>
    Microsoft.ApplicationInsights
    (https://www.nuget.org/packages/Microsoft.ApplicationInsights/) Licensed
    under the MIT license.
</p>
<p>
    Microsoft.ApplicationInsights.AspNetCore
    (https://www.nuget.org/packages/Microsoft.ApplicationInsights.AspNetCore/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Microsoft.ApplicationInsights.WorkerService
    (https://www.nuget.org/packages/Microsoft.ApplicationInsights.WorkerService/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Microsoft.AspNetCore.Authentication.JwtBearer
    (https://www.nuget.org/packages/Microsoft.AspNetCore.Authentication.JwtBearer/)
</p>
<p>
    Licensed under the Apache 2.0 license.
</p>
<p>
    Microsoft.AspNetCore.Authentication.OpenIdConnect
    (https://www.nuget.org/packages/Microsoft.AspNetCore.Authentication.OpenIdConnect/)
</p>
<p>
    Licensed under the Apache 2.0 license.
</p>
<p>
    Microsoft.AspNetCore.Diagnostics.HealthChecks
    (https://www.nuget.org/packages/Microsoft.AspNetCore.Diagnostics.HealthChecks/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Microsoft.AspNetCore.Http.Abstractions
    (https://www.nuget.org/packages/Microsoft.AspNetCore.Http.Abstractions)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Microsoft.AspNetCore.SpaServices.Extensions
    (https://www.nuget.org/packages/Microsoft.AspNetCore.SpaServices.Extensions)
</p>
<p>
    Licensed under the Apache 2.0 license.
</p>
<p>
    Microsoft.Azure.AppConfiguration.AspNetCore
    (https://www.nuget.org/packages/Microsoft.Azure.AppConfiguration.AspNetCore/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Microsoft.EntityFrameworkCore
    (https://www.nuget.org/packages/Microsoft.EntityFrameworkCore/)
</p>
<p>
    Licensed under the Apache 2.0 license.
</p>
<p>
    Microsoft.EntityFrameworkCore.SqlServer
    (https://www.nuget.org/packages/Microsoft.EntityFrameworkCore.SqlServer/)
</p>
<p>
    Licensed under the Apache 2.0 license.
</p>
<p>
    Microsoft.Extensions.Caching.StackExchangeRedis
    (https://www.nuget.org/packages/Microsoft.Extensions.Caching.StackExchangeRedis/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Microsoft.Extensions.Configuration
    (https://www.nuget.org/packages/Microsoft.Extensions.Configuration/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Microsoft.Extensions.Configuration.Abstractions
    (https://www.nuget.org/packages/Microsoft.Extensions.Configuration.Abstractions/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Microsoft.Extensions.Configuration.AzureAppConfigur
    (https://www.nuget.org/packages/Microsoft.Extensions.Configuration.AzureAppConfiguration/)
    Licensed under the MIT license.
</p>
<p>
    Microsoft.Extensions.Configuration.AzureKeyVault
    (https://www.nuget.org/packages/Microsoft.Extensions.Configuration.AzureKeyVault/)
</p>
<p>
    Licensed under the Apache 2.0 license.
</p>
<p>
    Microsoft.Extensions.Configuration.Binder
    (https://www.nuget.org/packages/Microsoft.Extensions.Configuration.Binder/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Microsoft.Extensions.DependencyInjection
    (https://www.nuget.org/packages/Microsoft.Extensions.DependencyInjection/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Microsoft.Extensions.DependencyInjection.Abstractio
    (https://www.nuget.org/packages/Microsoft.Extensions.DependencyInjection.Abstractions/)
    Licensed under the MIT license.
</p>
<p>
    Microsoft.Extensions.Diagnostics.HealthChecks
    (https://www.nuget.org/packages/Microsoft.Extensions.Diagnostics.HealthChecks/)
</p>
<p>
    Licensed under the Apache 2.0 license.
</p>
<p>
    Microsoft.Extensions.Identity.Stores
    (https://www.nuget.org/packages/Microsoft.Extensions.Identity.Stores/)
</p>
<p>
    Licensed under the Apache 2.0 license.
</p>
<p>
    Microsoft.Extensions.Logging
    (https://www.nuget.org/packages/Microsoft.Extensions.Logging/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Microsoft.Extensions.Options.ConfigurationExtension
    (https://www.nuget.org/packages/Microsoft.Extensions.Options.ConfigurationExtensions/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Microsoft.Graph (https://www.nuget.org/packages/Microsoft.Graph/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Newtonsoft.Json (https://www.nuget.org/packages/Newtonsoft.Json/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Rebus (https://www.nuget.org/packages/Rebus/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Rebus.AzureServiceBus
    (https://www.nuget.org/packages/Rebus.AzureServiceBus/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Rebus.ServiceProvider
    (https://www.nuget.org/packages/Rebus.ServiceProvider/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    Rxjs (https://github.com/reactivex/rxjs)
</p>
<p>
    Licensed under the Apache 2.0 license.
</p>
<p>
    Swashbuckle.AspNetCore
    (https://www.nuget.org/packages/Swashbuckle.AspNetCore/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    System.Security.Cryptography.Pkcs
    (https://www.nuget.org/packages/System.Security.Cryptography.Pkcs/)
</p>
<p>
    Licensed under the MIT license.
</p>
<p>
    tslib (https://github.com/Microsoft/tslib)
</p>
<p>
    Licensed under the 0BSD license.
</p>
<p>
    zone.js (https://github.com/angular/zone.js/)
</p>
<p>
    Licensed under the MIT license.
</p>